import { render, staticRenderFns } from "./TomaInspection.vue?vue&type=template&id=1359d70c&scoped=true"
import script from "./TomaInspection.vue?vue&type=script&lang=js"
export * from "./TomaInspection.vue?vue&type=script&lang=js"
import style0 from "./TomaInspection.vue?vue&type=style&index=0&id=1359d70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1359d70c",
  null
  
)

export default component.exports